import { useQuery } from '@tanstack/react-query';
import { classificationApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export function useClassifications() {
  return useQuery({
    queryKey: queryKeys.classifications.list(),
    queryFn: ({ signal }) =>
      classificationApiClient.list({}, toCancelToken(signal)),
    staleTime: 5 * 60_000,
    meta: { errorContext: 'classifications' },
  });
}
